export default "__VITE_ASSET__DODQshtn__"